import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import { Row, Col } from 'react-flexbox-grid'
import { Link as ScrollLink } from 'react-scroll'
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  Grade,
  GetStartedInput,
  AutocompleteSearch
} from '../../components'
import Styles from './AboutBanksInsurance.css'

@CSSModules(Styles, {allowMultiple:true})
export default class AboutBanksInsurance extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'Fossil fuel finance & insurance'
    const url = config.domain + config.routes.about

    const bannerImage = 'banks'
    const bannerHeadline = 'Fossil fuel finance & insurance'
    const bannerSubtitle = 'Banks and insurance companies support fossil fuel projects by financing and underwriting'

    const fossilFuelLendingCompanyTable = require( '../../../static/images/fossil-fuel-lending-company-table.png' )
    const fossilFuelInsuranceCompanyTable = require( '../../../static/images/fossil-fuel-insurance-company-table.png' )

    const bankIcon = require('../../../static/images/icn-ffb.svg')
    const insureIcon = require('../../../static/images/icn-ffi.svg')
    const riskyBusinessChartImg = require('../../../static/images/risky-business-chart-img.jpg')

    return (
      <div styleName='main'>
        {container.helmet(title, bannerSubtitle, url)}

        <ContainerDivs>
          <div styleName={'image-banner-'+bannerImage}>
            <h1 styleName='image-banner-headline'>{bannerHeadline}</h1>
          </div>
        </ContainerDivs>

        <ContainerDivs>
          <div styleName='lede'>
            <p>
              <b>Fossil Free Funds now incorporates banks and insurers into
              our fossil fuel ratings.</b> Financial companies are providing
              loans and underwriting that support fossil fuel
              projects – including tar sands, arctic drilling, and
              coal mining - but in order to keep global warming below 1.5°C,
              the world needs to rapidly transition away from fossil fuels.
            </p>
            <Row>
              <Col xs={12} sm={6}>
                <div styleName='lede-section-wrap'>
                  <div>
                    <h3 styleName='lede-icon-hl'>
                      <img src={bankIcon} alt='Banks' styleName='lede-icon'/>
                      Banks
                    </h3>
                    <p>
                      Commercial and investment banks' carbon-intensive
                      funding is fundamentally incompatible with reaching the
                      1.5-degree aligned global goal necessary to prevent
                      catastrophic climate harm.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={6}>
                <div styleName='lede-section-wrap b'>
                  <div>
                    <h3 styleName='lede-icon-hl'>
                      <img src={insureIcon} alt='Insurers' styleName='lede-icon' />
                      Insurers
                    </h3>
                    <p>
                      Primary insurers and reinsurers are continuing to
                      underwrite and invest in coal, oil, and gas, while
                      experiencing dramatic losses associated with
                      catastrophic weather-related events.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <div styleName='section'>
            <div styleName='search-bar-wrap'>
              <h3>
                Get started looking up funds
              </h3>
              <AutocompleteSearch destination='fossil-finance'/>
              <p>
                <Link to={config.routes.clean} title='Full list of funds' xstrong>
                  Full list<LinkIcon />
                </Link>
              </p>
            </div>
          </div>


          <div styleName='section'>
            <Row>
              <Col xs={12} sm={12} md={8}>
                <div styleName='padding-right-row'>
                  <h2>
                    Risky business
                  </h2>
                  <p>
                    <b>Since the Paris Agreement, the world's largest banks
                    have provided trillions in financing to the fossil
                    fuel industry.</b>
                  </p>
                  <p>
                    By continuing to provide support to high carbon companies
                    and projects, financial institutions are exacerbating the
                    climate crisis, delaying the transition to a clean energy
                    economy, and creating substantial portfolio risk for
                    investors.
                  </p>
                  <p>
                    <b>Climate change creates financial risk.</b> Investors
                    should be aware of which companies in their portfolios
                    are contributing to those risks.
                  </p>
                </div>
              </Col>
              <Col xs={12} sm={12} md={4}>
                <div styleName='risky-business-chart-img-flex'>
                  <img
                    src={riskyBusinessChartImg}
                    alt='Risky business'
                    styleName='risky-business-chart-img'
                  />
                </div>
              </Col>
            </Row>
          </div>

          <div styleName='a' id='methodology'/>
          <div styleName='section'>
            <div styleName='search-bar-wrap'>
              <h2>
                Methodology
              </h2>
              <p>
                The fossil fuel finance & insurance ratings use
                third-party expert data on bank lending and insurer policies
                from <b>Banking on Climate Chaos</b> and <b>Insure Our
                Future</b>.
              </p>

              <div styleName='scroll-button-flex'>
                <ScrollLink
                  to='methodology-fossil-fuel-finance'
                  spy
                  smooth
                  offset={0}
                  duration={500}
                  title='Fossil fuel finance'
                >
                  <button styleName='scroll-button'>
                    Fossil fuel finance<LinkIcon faclass='fa-angle-double-down'/>
                  </button>
                </ScrollLink>

                <ScrollLink
                  to='methodology-fossil-fuel-insurance'
                  spy
                  smooth
                  offset={0}
                  duration={500}
                  title='Fossil fuel insurance'
                >
                  <button styleName='scroll-button'>
                    Fossil fuel insurance<LinkIcon faclass='fa-angle-double-down' />
                  </button>
                </ScrollLink>
              </div>
            </div>
          </div>


          <div styleName='a' id='methodology-fossil-fuel-finance'/>
          <div styleName='section'>
            <h3>
              Fossil fuel finance
            </h3>
            <p>
              To rate mutual funds on fossil fuel finance, we use
              data from <Link
                to='https://www.bankingonclimatechaos.org/'
                title='Banking on Climate Chaos'
                xstrong
              >
                Banking on Climate Chaos
              </Link>.
              Banking on Climate Chaos looks at 65 of the largest
              commercial and investment banks
              and tracks their total fossil fuel financing:
              lending, and underwriting
              debt and equity issuances.
              The data covers 2021 through 2024. The top bank, JPMorgan Chase, had
              over $192 billion in fossil fuel financing over this time period.
              For our fund ratings, we normalize the bank financing
              amounts from $USD to a 0-10
              scale, where 10 is the worst score possible.
              These 0-10 figures represent a <b>company fossil fuel finance risk score</b>.
            </p>

            <div styleName='finance-company-table-img-wrap'>
              <Link
                to={config.domain + '/images/fossil-fuel-lending-company-table.png'}
                title='Fossil fuel finance company table'
                targetBlank
              >
                <img
                  src={fossilFuelLendingCompanyTable}
                  alt='Fossil fuel finance company table'
                  styleName='finance-company-table-img'
                />
                <span styleName='risky-business-chart-expand-label visible-xs'>
                  Click to enlarge<LinkIcon faclass='fa-expand'/>
                </span>
              </Link>
            </div>

            <p>
              If a fund invests in one of these banks, we flag the holding
              and display it on the fund profile.
            </p>
            <p>
              We then use the normalized financing amounts
              (0-10 points) to calculate a <b>
              fund fossil fuel finance risk score</b>.
              For each flagged bank holding, the company risk score is multiplied
              by the holding weight (the percent of the fund's portfolio
              that holding accounts for). For example, if a flagged bank
              holding had a company risk score of 5, and made up 2% of the
              fund, 10 points would be assigned to the fund (5 x 2).
              These points are summed up and represent the fund fossil fuel
              finance risk score.
            </p>
            <p>
              The last step is using the fund risk score to assign a <b>
              fund fossil fuel finance grade</b>.
              Funds are grouped into five tiers:
            </p>
            <table styleName='grade-tier-table'>
              <thead>
                <tr>
                  <th>
                    Grade
                  </th>
                  <th>
                    Risk score
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr><td><Grade grade={1} blocksmall /></td><td>0</td></tr>
                <tr><td><Grade grade={2} blocksmall /></td><td>0 - 11</td></tr>
                <tr><td><Grade grade={3} blocksmall /></td><td>11 - 22</td></tr>
                <tr><td><Grade grade={4} blocksmall /></td><td>22 - 35</td></tr>
                <tr><td><Grade grade={5} blocksmall /></td><td>35+</td></tr>
              </tbody>
            </table>
            <p>
              These tiers are determined using the distribution of results
              for funds in the research universe (open-end mutual funds and
                exchange-traded funds domiciled in the U.S. with at least
                50% invested in equities).
            </p>
            <p>
              Funds with no exposure to the
              banks from the Banking on Climate Chaos report are assigned
              an A grade. For funds that do invest in these banks,
              the grade tiers roughly place 1/4 in the B tier, 1/4 in the
              C tier, etc.
            </p>
            <p>
              In sum, the grades can be interepreted as saying: a fund
              with a worse grade has <b>more exposure</b> to banks from the Banking on
              Climate Chaos report, or exposure to banks with a <b>higher financing
              amount</b>, than funds with a better grade.
            </p>
          </div>


          <div styleName='a' id='methodology-fossil-fuel-insurance'/>
          <div styleName='section'>
            <h3>
              Fossil fuel insurance
            </h3>
            <p>
              To rate mutual funds on fossil fuel insurance, we use
              data from the <Link
                to='https://us.insure-our-future.com/wp-content/uploads/2024/12/IoF-Scorecard-2024.pdf'
                title='Insure Our Future Scorecard'
                xstrong
              >
                Insure Our Future Scorecard
              </Link>. Insure Our Future looks at 30 of the largest
              primary insurers and reinsurers and rates their fossil fuel
              insurance underwriting policies.
              For our fund ratings, we normalize the insurance policy ratings
               to a 0-10
              scale, where 10 is the worst score possible.
              These 0-10 figures represent a <b>company fossil fuel
              insurance risk score</b>.
            </p>

            <div styleName='finance-company-table-img-wrap'>
              <Link
                to={config.domain + '/images/fossil-fuel-insurance-company-table.png'}
                title='Fossil fuel insurance company table'
                targetBlank
              >
                <img
                  src={fossilFuelInsuranceCompanyTable}
                  alt='Fossil fuel insurance company table'
                  styleName='finance-company-table-img'
                />
                <span styleName='risky-business-chart-expand-label visible-xs'>
                  Click to enlarge<LinkIcon faclass='fa-expand'/>
                </span>
              </Link>
            </div>

            <p>
              If a fund invests in one of these insurers, we flag the holding
              and display it on the fund profile.
            </p>
            <p>
              We then use the normalized policy ratings
              (0-10 points)
              to calculate a <b>
              fund fossil fuel insurance risk score</b>.
              For each flagged insurance holding, the company risk score is
              multiplied
              by the holding weight (the percent of the fund's portfolio
              that holding accounts for). For example, if a flagged insurance
              holding had a company risk score of 5, and made up 2% of the
              fund, 10 points would be assigned to the fund (5 x 2).
              These points are summed up and represent the fund fossil fuel
              insurance risk score.
            </p>
            <p>
              The last step is using the fund risk score to assign a <b>
              fund fossil fuel insurance grade</b>.
              Funds are grouped into five tiers:
            </p>
            <table styleName='grade-tier-table'>
              <thead>
                <tr>
                  <th>
                    Grade
                  </th>
                  <th>
                    Risk score
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr><td><Grade grade={1} blocksmall /></td><td>0</td></tr>
                <tr><td><Grade grade={2} blocksmall /></td><td>0 - 9</td></tr>
                <tr><td><Grade grade={3} blocksmall /></td><td>9 - 16</td></tr>
                <tr><td><Grade grade={4} blocksmall /></td><td>16 - 24</td></tr>
                <tr><td><Grade grade={5} blocksmall /></td><td>24+</td></tr>
              </tbody>
            </table>
            <p>
              These tiers are determined using the distribution of results
              for funds in the research universe (open-end mutual funds and
                exchange-traded funds domiciled in the U.S. with at least
                50% invested in equities).
            </p>
            <p>
              Funds with no exposure to the
              insurers from the Insure Our Future Scorecard are assigned
              an A grade. For funds that do invest in these insurers,
              the grade tiers roughly place 1/4 in the B tier, 1/4 in the
              C tier, etc.
            </p>
            <p>
              In sum, the grades can be interpreted  as saying: a fund
              with a worse grade has <b>more exposure</b> to insurers from the
              Insure Our Future Scorecard, or exposure to insurers with <b>
              worse underwriting policy ratings</b>, than funds with a better grade.
            </p>
          </div>
        </ContainerDivs>

        <br/>
        <br/>
        <br/>
        <GetStartedInput/>

      </div>
    )
  }
}
